export default "__VITE_ASSET__CZf2vnIc__"